var _rect, _rect2, _path, _path2, _rect3, _path3, _path4, _path5, _rect4, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDynamicQrPreviewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 308,
    height: 140,
    viewBox: "0 0 308 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 134,
    y: 50,
    width: 40,
    height: 89,
    fill: "#B7BFD1",
    stroke: "#121212",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 19,
    width: 168,
    height: 89,
    rx: 7,
    fill: "#E4EDFF",
    stroke: "#121212",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70 26C70 22.134 73.134 19 77 19H231C234.866 19 238 22.134 238 26V29H70V26Z",
    fill: "#B7BFD1",
    stroke: "#121212",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70 98H238V101C238 104.866 234.866 108 231 108H77C73.134 108 70 104.866 70 101V98Z",
    fill: "#B7BFD1",
    stroke: "#121212",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 138,
    width: 240,
    height: 2,
    rx: 1,
    fill: "#121212"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M149.018 62.0964H152.272V78.3458H149.018V68.5961H145.763V71.846H136V62.0964H139.254V65.3463H142.509V62.0964H149.018ZM145.763 52.7497V49.4998H142.509V52.7497H145.763ZM136 78.3458H139.254V75.0959H136V78.3458ZM142.509 78.3458H145.763V75.0959H142.509V78.3458ZM165.29 52.7497V49.4998H162.036V52.7497H165.29ZM171.799 43V59.2495H155.527V43H171.799ZM168.545 46.2499H158.781V55.9996H168.545V46.2499ZM149.018 43H152.272V59.2495H136V43H149.018ZM149.018 46.2499H139.254V55.9996H149.018V46.2499ZM168.545 62.0964H171.799V78.3458H155.527V62.0964H168.545ZM168.545 65.3463H158.781V75.0959H168.545V65.3463ZM165.29 71.846V68.5961H162.036V71.846H165.29Z",
    fill: "#4575D5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M236 30L236.252 30.6819C238.835 37.6617 244.338 43.1649 251.318 45.7477L252 46L251.318 46.2523C244.338 48.8351 238.835 54.3383 236.252 61.3181L236 62L235.748 61.3181C233.165 54.3383 227.662 48.8351 220.682 46.2523L220 46L220.682 45.7477C227.662 43.1649 233.165 37.6617 235.748 30.6819L236 30Z",
    fill: "#1BEBA0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5 105C41.3 109.865 45.1354 113.7 50 115.5C45.1354 117.3 41.3 121.135 39.5 126C37.7 121.135 33.8646 117.3 29 115.5C33.8646 113.7 37.7 109.865 39.5 105Z",
    fill: "#0C5EFF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 87,
    width: 36,
    height: 4,
    rx: 2,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 137,
    y: 88,
    width: 34,
    height: 2,
    rx: 1,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 137,
    y: 88,
    width: 25,
    height: 2,
    rx: 1,
    fill: "#0C5EFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDynamicQrPreviewIcon);
export default __webpack_public_path__ + "static/media/dynamic-qr-preview-icon.8a3b6a3d41669e9b208dd47000cbc104.svg";
export { ForwardRef as ReactComponent };